import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumbs({ links }) {
  return (
    <nav className="text-gray-500 mb-4">
      <ul className="flex space-x-2">
        {links.map((link, index) => (
          <li key={index} className="inline">
            {index !== links.length - 1 ? (
              <>
                <Link to={link.path} className="text-blue-600 hover:underline">
                  {link.label}
                </Link>
                <span className="mx-2">/</span>
              </>
            ) : (
              <span>{link.label}</span>  // Dernier élément (page actuelle)
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Breadcrumbs;
